import React from "react";
import { Modal, Button } from "react-bootstrap";
import DynamicAsyncSelect from "./DynamicAsyncSelect";
import CreateNewCustomerForm from "./CreateNewCustomerForm";


export const normalizeCustomerOption = (option) => {
  if (!option) return null;
  const fd = option.fullData || {};
  const id = option.value ?? fd.customer_id ?? fd.id ?? fd.customerId ?? null;
  const full_name = fd.full_name ?? fd.name ?? option.label ?? "";
  const phone = fd.phone || fd.mobile || fd.mobile_no || (fd.name?.split("-")[0] || "");
  return id ? { customer_id: String(id), full_name, phone } : null;
};



const CustomerModal = ({
  showModal,
  setShowModal,
  customerType,
  setCustomerType,
  modalTitle,
  setModalTitle,
  setSelectedCustomerObj,
  setSelectedCustomerId,
  customerFormRef,
  setNewCustomerData,
  handleConfirm,
  errors
}) => {
  const rootContainer = document.getElementById("root-container");

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      size={customerType === "new" ? "lg" : "md"}
      dialogClassName={customerType === "new" ? "w-100" : ""}
      container={rootContainer}
      style={{ zIndex: 9999 }}
      centered
      backdrop={true}
    >
      <Modal.Header closeButton>
        <Modal.Title className="fs-6">{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        {(customerType === "existing" || customerType === "check-in-customer") ? (
          <div className="row g-3 py-3">
            <div className="col-10">
              <DynamicAsyncSelect
                placeholder="Choose Mobile No"
                path="customers" // Passed path if DynamicAsyncSelect supports it
                onChange={(selected) => {
                  const norm = normalizeCustomerOption(selected);
                  if (norm) {
                    setSelectedCustomerObj(norm);
                    setSelectedCustomerId(norm.customer_id);
                  }
                }}
                customerType={customerType}
              />
            </div>
            <div className="col-2 d-flex align-items-end mb-1">
              <button
                type="button"
                className="btn btn-outline-danger w-100"
                onClick={() => {
                  setCustomerType("new");
                  setModalTitle("Add New Customer");
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4.5"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line></svg>
              </button>
            </div>
          </div>
        ) : (
          <CreateNewCustomerForm
            ref={customerFormRef}
            newCustomer={(data) => setNewCustomerData(data)}
            errors={errors}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
        <Button
          variant="primary"
          onClick={() => {
            if (customerType === "new") {
              customerFormRef.current?.submitForm();
            } else {
              handleConfirm();
            }
          }}
        >
          {customerType === "new" ? "Add" : "Add Selection"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomerModal;
